export const LOADING = 'project/users/loading';
export const LOADED = 'project/users/loaded';

export const LOADED_USER_SIZE_DATA = 'project/users/loaded_user_size_data';
export const DELETED_FILES_SIZE_DATA = 'project/users/deleted_files_size_data';
export const ADDED_FILES_SIZE_DATA = 'project/users/added_files_size_data';
export const LOADED_USER_CONFIG = 'project/users/loaded_user_config';
export const CHANGED_LOGIN_PAGE = 'project/users/changed_login_page';
export const MANUALLY_SET_DARK_MODE = 'project/users/manually_set_dark_mode';
